var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBuyersHome(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Group 23622",
    xmlns: "http://www.w3.org/2000/svg",
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 5438",
    width: 75,
    height: 75,
    rx: 15,
    style: {
      fill: "#efefef"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": 1,
    d: "M28.281 12.642 16.423.784a2.675 2.675 0 0 0-3.784 0L.788 12.634l-.012.012A2.675 2.675 0 0 0 2.557 17.2H3.112v8.725a3.135 3.135 0 0 0 3.132 3.131h4.639a.852.852 0 0 0 .852-.852v-6.831a1.43 1.43 0 0 1 1.429-1.429H15.9a1.43 1.43 0 0 1 1.429 1.429v6.841a.851.851 0 0 0 .852.852h4.639a3.135 3.135 0 0 0 3.132-3.131v-8.726h.438a2.676 2.676 0 0 0 1.894-4.567zm0 0",
    transform: "translate(23.469 23.467)",
    style: {
      fill: "#7c7c7c"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuyersHome);
export default __webpack_public_path__ + "static/media/buyers_home.cbd0a83a08899b757ab8b0089ebbf64d.svg";
export { ForwardRef as ReactComponent };